import type { FlagProvider, FlagRoutes } from '@ecs-na/access-flag-service';

/**
 * Fully-qualified feature-flag keys.
 *
 * Convention (from the flag service): `<appId>.<domain>.<flagName>`,
 * e.g. `offers.hero.variant`. Declare keys here so every consumer references
 * the same string and typos surface at compile time. Add entries as real flags
 * are introduced.
 */
export const FlagKeys = {
  // Example of a Datadog-served flag. Datadog keys are flat identifiers (they do
  // not follow the Eppo `<appId>.<domain>.<flagName>` convention above). Add a
  // matching FLAG_ROUTES entry so it evaluates against Datadog:
  PUBLIC_EXP_DD_FCSB_AA_TEST: 'public_exp_dd_fcsb_aa_test',
  WEB_ECOPZ_PUBLIC_LOGIN_PAGE_TEST: 'web_ecopz_public_loginPageTest'
} as const;

/**
 * Per-flag routing table for the Eppo → Datadog migration.
 *
 * Only list flags that should evaluate against Datadog; every other key falls
 * through to {@link DEFAULT_FLAG_PROVIDER}. This map is the auditable source of
 * truth for migration state — moving a flag from Eppo to Datadog is a
 * single-line change reviewable in isolation.
 */
export const FLAG_ROUTES: FlagRoutes = {
  // Route migrated flags to Datadog here. Example:
  [FlagKeys.PUBLIC_EXP_DD_FCSB_AA_TEST]: 'datadog'
};

/** Provider used for any flag absent from {@link FLAG_ROUTES}. */
export const DEFAULT_FLAG_PROVIDER: FlagProvider = 'eppo'; 